/* global G */
import { curry, isStr, type PlatformEvent } from 'lib/util'
import status from 'model/_shared/collection/bluetooth/connection'

/**
 * List Connection Status Event Handler
 *
 * @param module - app module
 * @param component - action component
 * @param eventOrKey
 * @returns  connection statuses
 */
const listConnectionStatus = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  eventOrKey: PlatformEvent<{ key: string }> | string,
): Array<Object> => {
  const key = !eventOrKey || isStr(eventOrKey) ? eventOrKey : eventOrKey.detail.key
  const scope = key ? status.filter(item => item.key === key) : status

  return scope.map(item => ({
    ...item,
    value: module[G.ADAPTER][G.INTL]._t(
      `connectionStatus.${item.key}`,
      {
        ns: 'common',
        _key: `connectionStatus.${item.key}`,
        defaultValue: item.value,
      },
    ),
  }))
}

export default curry(listConnectionStatus)
